export const contractorConfig = {
  company: {
    name: "Zylker Greenscape Pvt. Ltd.",
    logo: "/logo1.png",
    address: [
      "14B, Northern Street",
      "Greater South Avenue",
      "New York, NY 10001",
      "United States"
    ]
  },

  invoice: {
    invoiceNumber: "INV-000001",
    invoiceDate: "05 Aug 2024",
    dueDate: "31 Aug 2024",
    clientName: "Jessica Brown",
    clientAddress: "321 Pine Rd, Houston, 77001 TX, United States",
    items: [
      {
        name: "Landscaping",
        desc: "Design & Installation",
        qty: "1.00",
        rate: "4,590.00",
        amount: "4,590.00"
      },
      {
        name: "Lawn Maintenance",
        desc: "Irrigation system installation & Weeding",
        qty: "1.00",
        rate: "1,800.00",
        amount: "1,800.00"
      },
      {
        name: "Hardscaping",
        desc: "Patios, walkways, retaining walls",
        qty: "650.00",
        unit: "Sq. Ft",
        rate: "15.00",
        amount: "9,750.00"
      }
    ],
    subTotal: "16,140.00",
    discount: "968.40",
    shipping: "1,000.00",
    advancePaid: "5,000.00",
    total: "12,688.76"
  },

  terms: {
    payment: "Due end of the month",
    footer:
      "All services provided are subject to the terms and conditions outlined in the contract agreement or engagement letter."
  },

  currency: "₹"
};
